<template>
  <b-modal
    :ref="`edit-modal-${test.id}`"
    size="lg"
    v-bind="$attrs"
    button-size="sm"
    hide-footer
  >
    <div id="add-tests-container">
      <b-form
        class="container justify-content-center"
        @submit.prevent="addTest"
      >
        <label for="select-course-for-add-test" class="input-label"
          >Course</label
        >
        <b-form-select
          id="select-course-for-add-test"
          v-model="selectedCourse"
          :options="courses"
          label-field="title"
          text-field="title"
          value-field="id"
          size="sm"
          class="form-control form-control-sm w-25 mb-4"
          disabled
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >Select Course</b-form-select-option
            >
          </template>
        </b-form-select>
        <div
          class="d-flex justify-content-start align-items-center flex-wrap border-bottom mb-4 pb-2"
        >
          <b-form-group
            id="test-title-id"
            class="pb-3 col-5"
            label="Full Test Title"
            label-for="full-title"
          >
            <b-form-input
              class="form-control form-control-sm"
              id="test-title"
              v-model="test.title"
              type="text"
              placeholder="Enter test title"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="test-total-marks-id"
            class="pb-3 col-5 px-3"
            label="Total Marks"
            label-for="test-total-marks"
          >
            <b-form-input
              class="form-control form-control-sm"
              id="test-total-marks"
              v-model.number="test.total_marks"
              type="number"
              min="0"
              placeholder="Enter Total Marks"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="test-weightage-marks-id"
            class="pb-3 col-5"
            label="Weightage Marks"
            label-for="test-weightage-marks"
          >
            <b-form-input
              class="form-control form-control-sm"
              id="test-weightage-marks"
              v-model.number="test.weightage_marks"
              type="number"
              placeholder="Enter Weightage Marks"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="test-type-id"
            class="pb-3 col-5 px-3"
            label="Test Type"
            label-for="test-type"
          >
            <b-form-select
              id="test-type"
              v-model="test.type"
              :options="testTypes"
              label-field="title"
              text-field="title"
              value-field="id"
              size="sm"
              class="form-control form-control-sm"
              required
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >Select Test Type</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </div>

        <div
          class="d-flex align-items-start"
          :class="
            test.subtests_available
              ? 'justify-content-between'
              : 'justify-content-start'
          "
        >
          <div v-if="test.subtests_available">
            Subtests ({{ test.subtests.length }})
          </div>
          <div
            class="d-flex align-items-center"
            :class="
              test.subtests_available
                ? 'justify-content-end'
                : 'justify-content-start'
            "
          >
            <b-form-group
              id="subtests-available-id"
              class="cursor-pointer d-flex"
              :class="test.subtests_available ? 'mx-3' : ''"
              :label="
                test.subtests_available ? 'Remove subtests' : 'Has Subsets?'
              "
              label-for="subtests-available"
            >
              <b-form-checkbox
                id="subtests-available"
                v-model="test.subtests_available"
                name="subtests_available-button"
                class="px-2"
                switch
              >
              </b-form-checkbox>
            </b-form-group>
            <b-button
              v-if="test.subtests_available"
              class="btn btn-sm btn-outline-brand"
              @click="addMoreSubtest()"
              >Add a subtest</b-button
            >
          </div>
        </div>

        <div v-if="test.subtests_available">
          <div
            v-for="(subtest, index) in test.subtests"
            :key="index"
            class="border rounded p-4 my-4 bg-white"
          >
            <div
              class="d-flex justify-content-start align-items-center flex-wrap"
            >
              <b-form-group
                id="subtest-title-id"
                class="pb-3 col-5"
                label="Full SubTest Title"
                label-for="full-title"
              >
                <b-form-input
                  class="form-control form-control-sm"
                  id="subtest-title"
                  v-model="subtest.title"
                  type="text"
                  placeholder="Enter test title"
                  @change="subtestIdToShow(subtest, index)"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="subtest-total-marks-id"
                class="pb-3 col-5 px-3"
                label="Total Marks"
                label-for="subtest-total-marks"
              >
                <b-form-input
                  class="form-control form-control-sm"
                  id="subtest-total-marks"
                  v-model.number="subtest.total_marks"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Enter Total Marks"
                  @change="subtest.weightage_marks = subtest.total_marks"
                ></b-form-input>
              </b-form-group>
              <button
                class="btn btn-sm btn-outline-danger"
                @click="discardCurrentSubtest(index)"
              >
                Discard
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <b-button
            type="submit"
            class="btn btn-sm btn-brand bg-brand mb-2 mt-3"
            :disabled="!marksTotalBalanced"
            >Submit</b-button
          >
          <p v-if="!marksTotalBalanced" class="mb-0 text-danger font-sm">
            {{ marksTotalError }}
          </p>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import {
  BTable,
  BFormSelect,
  BFormSelectOption,
  BButton,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
  BModal,
  BBadge,
} from "bootstrap-vue";
export default {
  name: "EditTests",
  props: {
    test: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BTable,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    BModal,
    BBadge,
  },
  beforeMount() {
    if (this.isUserGod) {
      this.getCourses();
    } else if (this.isUserAdmin || this.isUserOffice) {
      this.getCourses({ wing: this.user.wing });
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      courses: (state) => state.courses,
    }),
    ...mapGetters(["isUserGod", "isUserAdmin", "isUserOffice"]),
    sumOfAllSubtests() {
      let sum = 0;
      if (this.test.subtests_available) {
        for (let subtest of this.test.subtests) {
          sum += subtest.total_marks;
        }
        return sum;
      }
      return 0;
    },
    marksTotalBalanced() {
      return (
        (this.sumOfAllSubtests == this.test.total_marks &&
          this.test.subtests_available) ||
        !this.test.subtests_available
      );
    },
    marksTotalError() {
      if (!this.marksTotalBalanced) {
        return "The total of subtests doesn't equal to the total marks of the test. Please recheck.";
      }
      return "";
    },
  },
  data() {
    return {
      selectedCourse: null,
      testTypes: [
        {
          id: "written-test",
          title: "Written",
        },
        {
          id: "practical-test",
          title: "Practical",
        },
      ],
    };
  },
  mounted() {
    this.selectedCourse = this.test.course.id;
  },
  methods: {
    ...mapActions(["editTest", "getCourses"]),
    addTest() {
      console.log("addTest", { ...this.test });
      this.editTest({ ...this.test });
    },
    subtestIdToShow(subtest, index) {
      if (subtest.title) {
        this.test.subtests[index].id = `course_${
          this.selectedCourse
        }-test_${this.test.title
          .toLowerCase()
          .split(" ")
          .join("-")}-subtest_${index}_${subtest.title
          .toLowerCase()
          .split(" ")
          .join("-")}`;
      }
      return "";
    },
    addMoreSubtest() {
      this.test.subtests.push({
        id: "",
        title: "",
        total_marks: 0,
        weightage_marks: 0,
      });
    },
    discardCurrentSubtest(index) {
      this.test.subtests.splice(index, 1);
    },
  },
};
</script>
<style scoped>
.test-id-style {
  color: cadetblue;
  font-style: italic;
}
.input-label {
  font-size: 14px;
}
</style>
<style>
.form-group label {
  font-size: 14px !important;
}
</style>